import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import feather from "feather-icons";
import axios from "axios";
import { ReactSession } from "react-client-session";
ReactSession.setStoreType("localStorage");

const Cart = () => {
  const userId = ReactSession.get("welbeinguserId");
  const [cartItems, setCartItems] = useState([]);
  const [coupon, setCoupon] = useState("");
  const [total, setTotal] = useState(0);
  const [gst, setgst] = useState(0);
  const [shipping, setShipping] = useState(0);
  const [gtotal, setGTotal] = useState(0);
  const [offer, setOffer] = useState(0);

  // console.log(cartItems);

  const getCart = () => {
    const storedCartItems =
      JSON.parse(sessionStorage.getItem("cartItems")) || [];
    setCartItems(storedCartItems);
  };

  useEffect(() => {
    getCart();

    const intervalId = setInterval(() => {
      getCart();
    }, 2000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const removeProducts = (index) => {
    const updatedCart = [...cartItems];
    updatedCart.splice(index, 1);
    setCartItems(updatedCart);
    sessionStorage.setItem("cartItems", JSON.stringify(updatedCart));
    localStorage.setItem("cartItems", JSON.stringify(updatedCart));
  };

 useEffect(() => {
  if (!cartItems || cartItems.length === 0) {
    setTotal(0);
    setGTotal(0);
    setOffer(0);
    setShipping(0);
    setgst(0);
    return;
  }

  // Calculate sums
  let subtotal = 0;
  let total = 0;
  let weight = 0;
  
  cartItems.forEach((item) => {
    const itemWeight = parseFloat(item.weight.split(" ")[0]) || 0;
    subtotal +=  item.price * item.quantity;
    total += item.prices * item.quantity;
    weight +=  item.quantity * itemWeight;
  });

  // Calculate shipping
  let shipping;
  if (weight <= 1000) shipping = 70;
  else if (weight <= 2000) shipping = 120;
  else if (weight <= 3000) shipping = 140;
  else if (weight <= 4000) shipping = 180;
  else if (weight <= 5000) shipping = 220;
  else shipping = 250;

  // Calculate offer discount (capped at 100)
 
//  let discountAmount
//  let c_total = total * (offer/100);
// 					  if(c_total>100){
// 						  discountAmount = 100;
						   
// 					  }else{
// 						  discountAmount =c_total;
// 				      }
  
  // Calculate grand total
  const gTotal = Number(total) - Number(offer) + Number(shipping);

  // Update state
  setTotal(subtotal);
  setgst(total - subtotal);
  setShipping(shipping);
  setGTotal(gTotal);

}, [cartItems, offer, total, shipping,gtotal, offer]);

  const handleCoupon = (event) => {
    setCoupon(event.target.value); // Changed setInput to setLink
  };

  const fetchCouponData = async () => {
  try {
    // Validate coupon code first
    if (!coupon || coupon.trim() === '') {
      alert('Please enter a coupon code');
      return;
    }

    const response = await axios.post(
      `https://api.welbeing.in/coupon/`,
      { code: coupon }
    );

    // Check if response data exists and has the expected structure
    if (!response.data || !response.data.data) {
      alert('Invalid coupon response from server');
      return;
    }

    // Ensure the data is an array
    const coupons = Array.isArray(response.data.data) 
      ? response.data.data 
      : [response.data.data];

    const foundCoupon = coupons.filter(item => item.coupon_code === coupon);

    if (foundCoupon.length === 0) {
      alert('Coupon not found');
      return;
    }

    const currentDate = new Date();
    const offercoupon = foundCoupon[0];
    
    // Validate coupon dates
    const startDate = new Date(offercoupon.start_date);
    const endDate = new Date(offercoupon.end_date);

    if (currentDate < startDate) {
      alert('Coupon not yet available');
      return;
    }

    if (currentDate > endDate) {
      alert('Coupon has expired');
      return;
    }

    // Calculate discount
    const discountPercentage = parseFloat(offercoupon.discount) || 0;
    const discountAmount = total * (discountPercentage / 100);

    const couponData = {
      id: offercoupon.id,
      code: offercoupon.coupon_code,
      discount: discountPercentage,
      discountAmount: discountAmount
    };

    // Update state and storage
    setOffer(discountAmount);
    sessionStorage.setItem("offer", discountAmount);
    sessionStorage.setItem("coupon", JSON.stringify(couponData));

    alert(`Coupon applied! ${discountPercentage}% discount`);

  } catch (error) {
    console.error("Error fetching coupon data:", error);
    alert('Failed to apply coupon. Please try again.');
  }
};

  const handleCouponcode = async (event) => {
    event.preventDefault(); // Prevent default form submission
    // console.log("Coupon Code:", coupon);
    await fetchCouponData(); // Call function to fetch coupon data
  };
  

  useEffect(() => {
    feather.replace();
  }, []);

  const preOrderBadgeStyle = {
  position: 'absolute',
  top: '7px',
  right: '-10px',
  borderRadius: '10px',
  background: 'yellow',
  color: '#333',
  padding: '3px 7px',
  fontSize: '10px',
  fontWeight: 'bold',
  zIndex: 10,
  boxShadow: '0 0 3px rgba(0, 0, 0, 0.2)',
  transform: 'rotate(15deg)'
};

  return (
    <>
      <Header />

      <main class="main">
        <div className="breadcrumb-wrap" id="breadcrumb-margin">
          <div className="banner" style={{minHeight:'10px'}}>
            <img
              class="bg-img bg-top"
              src="assets/images/inner-page/banner-p.html"
              alt="banner"
            />

            <div class="container-lg">
              <div class="breadcrumb-box">
                <div class="heading-box">
                  <h1>Cart</h1>
                </div>
                <ol class="breadcrumb">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      <i data-feather="chevron-right"></i>
                    </a>
                  </li>
                  <li class="current">
                    <a href="/cart">Cart</a>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <section className="section-b-space card-page">
          <div className="container-lg">
            {cartItems.length === 0 ? (
    <div className="row g-3 g-md-4 cart">
      <div className="col-12">
        <div className="text-center py-5">
          <h5 className="heading-2 mb-10">Your Cart</h5>
          <h6 className="text-body">Please add items to your cart.</h6>
         
          <a href="/shop" className="btn btn-solid  px-4">
            <i className="fi-rs-arrow-left mr-10"></i>Continue Shopping
          </a>
        </div>
      </div>
    </div>
  ) : (
                         <div className="row g-3 g-md-4 cart">
                
              <div className="col-md-7 col-lg-8">
                <div className="cart-wrap">
                  <div className="items-list">
                      <table className="table cart-table m-md-0">
                        <thead>
                          <tr>
                            <th className="d-none d-sm-table-cell">PRODUCT</th>
                            <th className="d-none d-sm-table-cell">PRICE</th>
                            <th className="d-none d-lg-table-cell">QUANTITY</th>
                            <th className="d-none d-xl-table-cell">TOTAL</th>
                            <th className="d-none d-xl-table-cell">ACTION</th>
                          </tr>
                        </thead>

                        <tbody>
                          {cartItems.map((item, index) => (
                            <tr key={index}>
                              <td>
                                <div className="product-detail">
                                  <div
                                    style={{
                                      position: "relative",
                                      display: "inline-block",
                                    }}
                                  >
                                    <img
                                      className="pr-img"
                                      src={`https://api.welbeing.in/uploads/products/${item.image}`}
                                      alt="image"
                                    />
                                     
                                    
                                   {/* {(item.preOrder === 'yes' || item.stock < item.quantity) && (
                                        <span style={preOrderBadgeStyle}>Pre Order</span>
                                    )} */}
                                    {(item.orderType === 'preorder') && (
                                        <span style={preOrderBadgeStyle}>Pre Order</span>
                                    )}
                                  </div>
                                  <div className="details">
                                    <h4 className="title-color font-default2">
                                      {item.product} <br />
                                      <small>{item.code}</small>
                                    </h4>

                                    <span className="size gap-2 d-flex d-sm-none">
                                      Price : <span>₹{item.price} </span>{" "}
                                    </span>
                                    <span className="size gap-2 d-flex d-sm-none">
                                      Quantity : <span>X{item.quantity}</span>{" "}
                                    </span>
                                    <div className="plus-minus mt-2 d-inline-flex d-lg-none">
                                      <a href="">
                                        <i data-feather="trash"></i>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </td>

                              <td className="price d-none d-sm-table-cell">
                                ₹{item.price}{" "}
                              </td>
                              <td className="d-none d-lg-table-cell">
                                <div className="plus-minus">
                                  X{item.quantity}
                                </div>
                              </td>
                              <td className="total d-none d-xl-table-cell">
                                ₹ {item.price* item.quantity}{" "}
                              </td>
                              <td className="total d-none d-xl-table-cell">
                                <a
                                  href=""
                                  onClick={() => removeProducts(index)}
                                >
                                  <i data-feather="trash"></i>
                                </a>
                              </td>
                            </tr>
                            ))}
                        </tbody>
                      </table>
                    
                  </div>
                </div>
              </div>

              <div className="col-md-5 col-lg-4">
                <div className="summery-wrap">
                  <div className="coupon-box">
                    <h5 className="cart-title">Coupon</h5>
                    <div className="text-wrap">
                      <input
                        className="input-promo-code"
                        name="code"
                        type="text"
                        placeholder="coupon code"
                        value={coupon}
                        onChange={handleCoupon}
                      />
                      <br />
                      <button
                        onClick={handleCouponcode}
                        className="btn btn-outline btn-sm"
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                  <div className="cart-wrap grand-total-wrap">
                    <div>
                      <div className="order-summery-box">
                        <h5 className="cart-title">Card Totals</h5>

                        <ul className="order-summery">
                          <li>
                            <span>Subtotals:</span>
                            <span>₹{total.toFixed(2)}</span>
                          </li>
                          <li>
                            <span>Gst:</span>
                            <span className="theme-color">
                              ₹ {gst.toFixed(2)}
                            </span>
                          </li>

                          <li>
                            <span>Shipping:</span>
                            <span className="theme-color">
                              ₹ {shipping.toFixed(2)}
                            </span>
                          </li>

                         
                            <li className="coupon-discount">
                              <span>Coupon Discount</span>
                              <span>-₹{offer.toFixed(2)}</span>
                            </li>

                          <li className="pb-0">
                            <span>Total Amount</span>
                            <span>₹{gtotal.toFixed(2)}</span>
                          </li>
                        </ul>
                        <div className="row g-3 mt-2">
                          <div className="col-6 col-md-12">
                            <a
                              href="/checkout"
                              className="btn-solid checkout-btn"
                            >
                              Checkout <i className="arrow"></i>
                            </a>
                          </div>
                          <div className="col-6 col-md-12">
                            <a
                              href="/shop"
                              className="btn-outline w-100 justify-content-center checkout-btn"
                            >
                              Back To Shop
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
             )}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};
export default Cart;
